export const useLibraryBooksSetAsMainContent = () => {
  const profileLoadFromNetwork = useProfileLoadFromNetwork();
  const run = async (id: string): Promise<boolean> => {
    try {
      await useApiFetch(URI.MemberProfile, {
        method: 'POST',
        body: {
          userAssociatedAppId: id,
        },
      });

      await profileLoadFromNetwork.run(false);

      await useAppInit('/');
      return true;
    } catch (e) {
      return false;
    }
  };
  return {
    run,
  };
};
